import { target, targets, targetable } from '@github/catalyst/lib/targetable'

// Seleção em massa de documentos no dashboard. Sem handlers inline (CSP estrito):
// tudo via addEventListener. As ações reescrevem a action de um <form> oculto e
// injetam os ids selecionados como inputs ocultos, no mesmo padrão do dashboard-dropzone.
export default targetable(class extends HTMLElement {
  static [targets.static] = ['checkbox']
  static [target.static] = ['bar', 'count', 'selectAll', 'form', 'idsContainer', 'toggleButton']

  connectedCallback () {
    this.selected = new Set()

    this.checkbox.forEach((cb) => cb.addEventListener('change', this.onCheckboxChange))
    this.selectAll?.addEventListener('change', this.onSelectAll)
    this.toggleButton?.addEventListener('click', this.onToggleMode)
    this.querySelector('[data-bulk-close]')?.addEventListener('click', this.onToggleMode)

    this.actionButtons.forEach((btn) => btn.addEventListener('click', this.onAction))
  }

  get actionButtons () {
    return Array.from(this.querySelectorAll('[data-bulk-action]'))
  }

  get selecting () {
    return this.classList.contains('selecting')
  }

  onToggleMode = () => {
    this.classList.toggle('selecting')
    this.toggleButton.classList.toggle('btn-neutral')

    if (!this.selecting) this.clear()
  }

  onCheckboxChange = (e) => {
    if (e.target.checked) this.selected.add(e.target.value)
    else this.selected.delete(e.target.value)

    this.refresh()
  }

  onSelectAll = (e) => {
    this.checkbox.forEach((cb) => {
      cb.checked = e.target.checked

      if (e.target.checked) this.selected.add(cb.value)
      else this.selected.delete(cb.value)
    })

    this.refresh()
  }

  refresh = () => {
    const n = this.selected.size

    if (this.count) this.count.textContent = n
    this.bar?.classList.toggle('hidden', n === 0)

    if (this.selectAll) {
      this.selectAll.checked = n > 0 && n === this.checkbox.length
      this.selectAll.indeterminate = n > 0 && n < this.checkbox.length
    }
  }

  clear = () => {
    this.selected.clear()
    this.checkbox.forEach((cb) => { cb.checked = false })
    this.refresh()
  }

  onAction = async (e) => {
    const btn = e.currentTarget
    const ids = Array.from(this.selected)

    if (ids.length === 0) return

    // Mover abre uma modal (turbo-frame) carregando os ids selecionados.
    if (btn.dataset.bulkAction === 'move') {
      const params = ids.map((id) => `ids[]=${encodeURIComponent(id)}`).join('&')
      const a = document.createElement('a')

      a.href = `${btn.dataset.url}?${params}`
      a.dataset.turboFrame = 'modal'
      a.classList.add('hidden')

      document.body.append(a)
      a.click()
      a.remove()

      return
    }

    if (btn.dataset.confirm && !(await window.Dialog.confirm(btn.dataset.confirm, { danger: true }))) return

    this.form.action = btn.dataset.url
    this.idsContainer.innerHTML = ''

    ids.forEach((id) => {
      const input = document.createElement('input')

      input.type = 'hidden'
      input.name = 'ids[]'
      input.value = id

      this.idsContainer.append(input)
    })

    this.form.requestSubmit()
  }
})
